import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  infoChartWrapper: {
    margin: theme.spacing(6),
    boxShadow: '0px 4px 4px #00000005',
    borderRadius: theme.spacing(10),
    // width: '100%',
    background: `${theme.palette.background.paper} 0% 0% no-repeat padding-box`,
  },
  wrappedContainer: {
    padding: theme.spacing(11),
  },
}));
